module.exports = __webpack_public_path__ + "static/media/upper_case.2f36f96d.svg";